import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { FacilityService } from 'services/facility.service';

import facilitiesMapHtml from './facilities-map.html';
import './facilities-map.scss';



@Component({
  selector: 'gw-facilities-map',
  template: facilitiesMapHtml,
})
export class FacilitiesMapComponent implements OnInit {
  public google = (<any>window).google;
  public facilities = [];

  @Input() category: string;
  @Input() country: string;

  constructor(
    @Inject('NgMap') private ngMap,
    @Inject(FacilityService) private facilityService: FacilityService,
  ) {}

  async ngOnInit() {
    switch (this.category) {
      case 'global-embassy':
        this.facilities = await this.showGlobalEmbassies();
        break;
    }

    this.calculateCenter();
  }

  calculateCenter() {
    const bounds = new this.google.maps.LatLngBounds();

    this.facilities.forEach((facility) => {
      const latlng = new this.google.maps.LatLng(facility.latitude, facility.longitude);
      bounds.extend(latlng);
    });

    this.ngMap.getMap().then((map) => {
      map.setCenter(bounds.getCenter());
      map.fitBounds(bounds);
    });
  }

  async showGlobalEmbassies() {
    try {
      const embassies = await this.facilityService.getGlobalEmbassies(this.country);
      return embassies;
    } catch (e) {
      throw e;
    }
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/facilities-map/facilities-map.component.ts